"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_TYPE = exports.ICONS = void 0;
var ICONS = {
  THUMBS_UP: 'ThumbUp',
  THUMBS_DOWN: 'ThumbDown',
  THUMBS_UP_VALUE: '1',
  THUMBS_DOWN_VALUE: '0'
};
exports.ICONS = ICONS;
var ICON_TYPE = {
  normal: {
    color: 'greyMediumDark',
    size: 'normal'
  },
  selected: {
    color: 'secondaryBlue',
    size: 'normal'
  }
};
exports.ICON_TYPE = ICON_TYPE;